module.exports = __webpack_public_path__ + "img/title-color.9335e72f.svg";